import { render, staticRenderFns } from "./PTSIProductionPlaceTable.vue?vue&type=template&id=c6b3337c"
import script from "./PTSIProductionPlaceTable.vue?vue&type=script&lang=js"
export * from "./PTSIProductionPlaceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports